import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = ({ user, logout }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="header">
      <Link to="/" className="logo"><img src={process.env.PUBLIC_URL + '/CPL_logo-768x768.webp'} alt="CPL Logo" style={{width: '51px', height: 'auto'}} /></Link>
      <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
        ☰
      </div>
        <nav className={menuOpen ? 'nav open' : 'nav'}>
          <Link to="/dice-tracker" onClick={() => setMenuOpen(false)}>Dice Score Tracker</Link>
          <Link to="/bank-tracker" onClick={() => setMenuOpen(false)}>Bank Roll Tracker</Link>
          <Link to="/leaderboard" onClick={() => setMenuOpen(false)}>Leaderboard</Link>
          <Link to="/teams" onClick={() => setMenuOpen(false)}>Teams</Link>
          <Link to="/membership" onClick={() => setMenuOpen(false)}>Membership</Link>
          <Link to="/about" onClick={() => setMenuOpen(false)}>About</Link>
          {user?.role === 'admin' && <Link to="/admin" onClick={() => setMenuOpen(false)}>Admin Panel</Link>}
        </nav>
      <div className="auth">
        {user ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <span style={{ color: 'white', fontWeight: '600' }}>Welcome, {user.firstName || user.nickname}</span>
            <button
              onClick={logout}
              style={{
                padding: '8px 16px',
                background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                color: 'white',
                border: 'none',
                borderRadius: '25px',
                cursor: 'pointer',
                fontWeight: '600',
                fontSize: '14px',
                transition: 'all 0.3s ease',
                boxShadow: '0 2px 4px rgba(30, 60, 114, 0.3)'
              }}
              onMouseOver={(e) => {
                e.target.style.transform = 'translateY(-1px)';
                e.target.style.boxShadow = '0 4px 8px rgba(30, 60, 114, 0.4)';
              }}
              onMouseOut={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 2px 4px rgba(30, 60, 114, 0.3)';
              }}
            >
              Logout
            </button>
          </div>
        ) : (
          <Link
            to="/login"
            style={{
              padding: '8px 16px',
              background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
              color: 'white',
              textDecoration: 'none',
              borderRadius: '25px',
              fontWeight: '600',
              fontSize: '14px',
              display: 'inline-block',
              transition: 'all 0.3s ease',
              boxShadow: '0 2px 4px rgba(30, 60, 114, 0.3)',
              textAlign: 'center'
            }}
            onMouseOver={(e) => {
              e.target.style.transform = 'translateY(-1px)';
              e.target.style.boxShadow = '0 4px 8px rgba(30, 60, 114, 0.4)';
              e.target.style.textDecoration = 'none';
            }}
            onMouseOut={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 2px 4px rgba(30, 60, 114, 0.3)';
              e.target.style.textDecoration = 'none';
            }}
          >
            Login
          </Link>
        )}
      </div>
    </header>
  );
};

export default Header;